// A Font Awesome Free glyph. `name` is a class string from lib/icons (e.g.
// 'fa-solid fa-cloud'); `className` carries whatever the layout needs, which is
// where the text-glyph spans these replaced used to hold their styling.
//
// Always decorative: every call site pairs the icon with a visible label or an
// aria-label on the control, so the glyph itself is hidden from screen readers.
export default function Icon({ name, className = '' }) {
  if (!name) return null;
  return <i className={`${name} ${className}`.trim()} aria-hidden="true" />;
}
